var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"class-display-item",class:{
    'is-selected': _vm.isSelected,
  }},[_c('div',{staticClass:"class-name"},[_vm._v(_vm._s(_vm.formatClass(_vm.classData)))])])}
var staticRenderFns = []

export { render, staticRenderFns }